import React from 'react';
import clsx from 'clsx';
import Backdrop from '@material-ui/core/Backdrop';
import CircularProgress from '@material-ui/core/CircularProgress';
import { useStyles } from './styles';
import NewSidebar from '../NewSideBar';
import { useConfig } from 'hook/config';

export default function Layout({
  children,
  title = '',
  route,
  specificRoute,
  backArrow = false,
  handleDateChange = () => {},
  isLoading = false,
  calendarWeek = true,
  calendarDay = true,
  calendarRange = false,
  showToday = false,
  calendarMonth = false,
  showHeader = true,
  handleCleanCheckbox = null,
  startNull = null,
  startToday = false,
  newTittleContainerStyle = false,
  titleContainerStyle = {},
}) {
  const classes = useStyles();
  const { config } = useConfig();

  return (
    <div className={classes.root}>
      <NewSidebar
        title={title}
        route={route}
        specificRoute={specificRoute}
        backArrow={backArrow}
        handleDateChange={handleDateChange}
        calendarWeek={calendarWeek}
        calendarRange={calendarRange}
        showToday={showToday}
        calendarMonth={calendarMonth}
        calendarDay={calendarDay}
        handleCleanCheckbox={handleCleanCheckbox}
        showHeader={showHeader}
        startNull={startNull}
        startToday={startToday}
        newTittleContainerStyle={newTittleContainerStyle}
        titleContainerStyle={titleContainerStyle}
      />
      <Backdrop className={classes.backdrop} open={isLoading}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <main
        className={clsx(
          classes.content,
          config.open ? classes.mainDrawerOpen : classes.mainDrawerCollapsed
        )}
      >
        <>{children}</>
      </main>
    </div>
  );
}
